import { useState, useEffect, ChangeEvent } from 'react';
import {
  //  getHeadTypeLoftData,
  getHeadTypeFamilyData,
  getFamilyData,
  getHeadModelHandForDropdownDtoData,
  getHeadModelsByManufacturerAndTypeForDropdownData,
  getHandLookupData,
  getHeadWeightLocationData,
  getHeadWeightNumberData,
  getHeadWeightNumberLookupData,
  getCtLocationData,
  getSleeveData,
  getSwingWtPrefixData,
  getSwingWtSuffixData,
  getShaftByShaftNameForDropdownData,
  getSettingsData,
  getGripSizeData,
  getShaftLengthDigitData,
  getShaftLengthFractionData,
  getShaftTippingFractionData,
  getFractionData,
  getDigitData,
  //  getLoftData,
  getHybridShaftByShaftNameForDropdownData,
  getHeadModelsByManufacturerAndTypeForDropdownDataHybrids,
  getHeadModelsByManufacturerAndTypeForDropdownDataFairways,
  getHeadWeightLocationLookupData,
  getLoftsAndHandAndHeadModelData,
  getHeadWeightLocationAftData,
  getHeadWeightNumberAftData,
} from '@/service/TourBagStaticService';
import {
  HandLookup,
  HeadModelHandForDropdownDto,
  HeadModelForDropdownDto,
  HeadWeightLocationDto,
  HeadWeightLocationLookup,
  HeadWeightNumber,
  HeadWeightNumberLookup,
  ShaftByShaftNameForDropdown,
  //Loft,
  LoftHandHeadModel,
  Family,
  HeadWeightLocationAftDto,
  HeadWeightNumberAftDto,
} from '@/api/models';
import EditableDropdown from '@/common/EditableDropdown';
import EditableTile from '@/common/EditableTile';
import { IDropdownOption } from '@/common/EditableDropdown/EditableDropdown';
import { TourBagDetail } from '@/api/models';
import { SerialMstrDetails, CTData } from '@/api/models/serialNumber';
import SerialNumberAutocomplete from '../SerialNumberAutocomplete';
import useOnlineStatus from '@/hooks/useOnlineStatus';
import { createCombinedShaftLengthDigitFractionList, createCombinedShaftTippingDigitFractionList } from '@/utils';
import { ShaftLengthDigitFractionDto } from '@/utils/createCombinedShaftLengthDigitFractionList';
import { ShaftTippingDigitFraction } from '@/utils/createCombinedShaftTippingDigitFractionList';
import styles from './Edit.module.scss';
import clubStyles from '../Club.module.scss';
import { ShaftHelper, FamilyHelper } from '@/library';
import { IShaftOptionMap } from '@/library/ShaftHelper';

const sanitize = (value: string) => {
  return value.replace(/[^0-9.,]/g, ''); // keep only digits + dot + comma
};

// Add type for the onSelect callback
interface ISerialNumberData {
  serialNumber: string;
  details: SerialMstrDetails & {
    hand: string;
    modelName: string;
    loftName: string;
    titleistLoft: string | number;
    headModelId?: number;
  };
  ctData: CTData;
}

interface IProps {
  driver: TourBagDetail;
  headTypeId: number;
  closeEditForm: () => void;
  pageType: string; //Edit, Copy, Add
  // eslint-disable-next-line no-unused-vars
  saveEditForm: (tourBag: TourBagDetail) => void;
}

interface IWeightCodes {
  swingWeightId: number; //autonumber
  name: string; //concatenation of prefix+suffix
  swingWtPrefixId: number;
  swingWtPrefixName: string;
  swingWtSuffixId: number;
  swingWtSuffixName: string;
}

export default function Edit({ driver, saveEditForm, headTypeId, closeEditForm, pageType }: IProps) {
  const isOnline = useOnlineStatus();
  const [thisDriver, setThisDriver] = useState({ ...driver, ct: driver.ct || 0 });
  const [currentHandId, setCurrentHandId] = useState(0); //the driver saves hand as "RH" and not a number. So need to save it in state to make lookups easier
  const [shaftLengthName, setShaftLengthName] = useState(''); //driver doesn't have a field to uniquely identify the length. So use this instead.
  const [handData, setHandData] = useState([] as HandLookup[]);
  const [familyOptions, setFamilyOptions] = useState([] as IDropdownOption[]);
  const [weightLocationData, setWeightLocationData] = useState([] as HeadWeightLocationDto[]);
  const [weightLocationLookupData, setWeightLocationLookupData] = useState([] as HeadWeightLocationLookup[]);
  const [weightLocationOptions, setWeightLocationOptions] = useState([] as IDropdownOption[]);
  const [weightNumberData, setWeightNumberData] = useState([] as HeadWeightNumber[]);
  const [weightNumberLookupData, setWeightNumberLookupData] = useState([] as HeadWeightNumberLookup[]);
  const [weightNumberOptions, setWeightNumberOptions] = useState([] as IDropdownOption[]);
  const [weightLocationAftData, setWeightLocationAftData] = useState([] as HeadWeightLocationAftDto[]);
  const [weightNumberAftData, setWeightNumberAftData] = useState([] as HeadWeightNumberAftDto[]);
  const [weightLocationAftOptions, setWeightLocationAftOptions] = useState([] as IDropdownOption[]);
  const [weightNumberAftOptions, setWeightNumberAftOptions] = useState([] as IDropdownOption[]);

  const [handModels, setHandModels] = useState([] as HeadModelHandForDropdownDto[]);
  const [familyModelData, setFamilyModelData] = useState([] as HeadModelForDropdownDto[]);
  const [modelOptions, setModelOptions] = useState([] as IDropdownOption[]);
  const [loftOptions, setLoftOptions] = useState([] as IDropdownOption[]);
  const [loftData, setLoftData] = useState([] as LoftHandHeadModel[]);
  //  const [loftData, setLoftData] = useState([] as Loft[]);
  const [ctLocationOptions, setCtLocationOptions] = useState([] as IDropdownOption[]);
  const [swingWtData, setSwingWtData] = useState([] as IWeightCodes[]);
  const [swingWtOptions, setSwingWtOptions] = useState([] as IDropdownOption[]);
  const [swingWtListId, setSwingWtListId] = useState(0); //need to save the mapping id b/c it's not in the driver record
  const [shaftDropdownData, setShaftDropdownData] = useState<IShaftOptionMap>();
  //const [shaftOptions, setShaftOptions] = useState([] as IDropdownOption[]);
  const [shaftId, setShaftId] = useState(''); //driver doesn't store shaftID, so need to do it here
  const [settingOptions, setSettingOptions] = useState([] as IDropdownOption[]);
  const [sleeveOptions, setSleeveOptions] = useState([] as IDropdownOption[]);
  const [gripSizeOptions, setGripSizeOptions] = useState([] as IDropdownOption[]);
  const [shaftLengthFractionData, setShaftLengthFractionData] = useState([] as ShaftLengthDigitFractionDto[]);
  const [shaftLengthFractionOptions, setShaftLengthFractionOptions] = useState([] as IDropdownOption[]);
  const [shaftTippingFractionData, setShaftTippingFractionData] = useState([] as ShaftTippingDigitFraction[]);
  const [shaftTippingFractionOptions, setShaftTippingFractionOptions] = useState([] as IDropdownOption[]);
  const [shaftTippingName, setTippingName] = useState(''); //driver doesn't have a field to uniquely identify the length. So use this instead.
  const showWeightAft = [1, 2].includes(headTypeId); // is driver or fairway

  const handOptions = [
    { id: 'RH', label: 'Right' },
    { id: 'LH', label: 'Left' },
  ] as IDropdownOption[];
  const rndRibOptions = [
    { id: 'Round', label: 'Round' },
    { id: 'Rib', label: 'Rib' },
  ] as IDropdownOption[];
  const logoOptions = [
    { id: 'Up', label: 'Up' },
    { id: 'Down', label: 'Down' },
  ] as IDropdownOption[];

  useEffect(() => {
    const asyncProc = async () => {
      const handLookup = await getHandLookupData();
      setHandData(handLookup);
      const currentHandIdData = getCurrentHandId(thisDriver.hand, handLookup);
      setCurrentHandId(currentHandIdData);

      const headTypeFamilyData = await getHeadTypeFamilyData(headTypeId);
      let familyModels = [] as HeadModelForDropdownDto[];
      switch (headTypeId) {
        case 1: //driver
          familyModels = await getHeadModelsByManufacturerAndTypeForDropdownData();
          break;
        case 2: //fairway
          familyModels = await getHeadModelsByManufacturerAndTypeForDropdownDataFairways();
          break;
        case 3: //hybrid
          familyModels = await getHeadModelsByManufacturerAndTypeForDropdownDataHybrids();
          break;
      }

      setFamilyModelData(familyModels);
      const familyData = await getFamilyData(headTypeFamilyData.map((d) => d.familyId));
      setFamilyOptions(
        familyData.map((family) => {
          return { id: family.familyId.toString(), label: family.name } as IDropdownOption;
        }),
      );
      const handModelList = await getHeadModelHandForDropdownDtoData();
      setHandModels(handModelList);
      const familyModelList = getModels(thisDriver.familyId, currentHandIdData, handModelList, familyModels) || [];
      setModelOptions(
        familyModelList.map((model) => {
          return { id: model.headModelId?.toString() || '', label: model.name } as IDropdownOption;
        }),
      );

      //const lofts = await getLoftData();
      //setLoftData(lofts);
      const lofts = await getLoftsAndHandAndHeadModelData();
      setLoftData(lofts);
      setLoftOptions(getLoftOptions(currentHandIdData, thisDriver.headModelId || 0, lofts));

      const headWeightLocationData = await getHeadWeightLocationData();
      setWeightLocationData(headWeightLocationData);
      // weight aft location data
      const headWeightLocationAftData = await getHeadWeightLocationAftData();
      setWeightLocationAftData(headWeightLocationAftData);
      const headWeightLocationLookup = await getHeadWeightLocationLookupData();
      setWeightLocationLookupData(headWeightLocationLookup);
      // assign for both aft and fwd
      assignWeightLocationOptions(thisDriver.headModelId || 0, headWeightLocationData, headWeightLocationLookup);
      assignWeightLocationAftOptions(thisDriver.headModelId || 0, headWeightLocationAftData, headWeightLocationLookup);

      let ctLocationData = await getCtLocationData();
      setCtLocationOptions(
        ctLocationData.map((ct) => {
          return { id: ct.name.toString(), label: ct.name } as IDropdownOption;
        }),
      );

      const headWeightNumberData = await getHeadWeightNumberData();
      setWeightNumberData(headWeightNumberData);
      // weight aft number data
      const headWeightNumberAftData = await getHeadWeightNumberAftData();
      setWeightNumberAftData(headWeightNumberAftData);
      const headWeightNumberLookup = await getHeadWeightNumberLookupData();
      setWeightNumberLookupData(headWeightNumberLookup);
      // assign for both aft and fwd
      assignWeightNumberOptions(thisDriver.headModelId || 0, headWeightNumberData, headWeightNumberLookup);
      assignWeightNumberAftOptions(thisDriver.headModelId || 0, headWeightNumberAftData, headWeightNumberLookup);

      const settingsData = await getSettingsData();
      setSettingOptions(
        settingsData.map((s) => {
          return { id: s.settingId.toString(), label: s.name.toString() } as IDropdownOption;
        }),
      );
      const sleeveData = await getSleeveData();
      setSleeveOptions(
        sleeveData.map((sleeve) => {
          return { id: sleeve.sleeveId.toString(), label: sleeve.name.toString() } as IDropdownOption;
        }),
      );

      const gripSizeData = await getGripSizeData();
      setGripSizeOptions(
        gripSizeData.map((grip) => {
          return { id: grip.gripSizeId.toString(), label: grip.name.toString() } as IDropdownOption;
        }),
      );

      //get swing weight lists and map them into a single list with a unique identifier
      const swingWtPrefix = await getSwingWtPrefixData();
      const swingWtSuffix = await getSwingWtSuffixData();
      let swingWeights = [] as IWeightCodes[];
      let swingWeightId = 1;
      swingWtPrefix.forEach((prefix) => {
        swingWtSuffix.forEach((suffix) => {
          swingWeights.push({
            swingWeightId: swingWeightId++,
            name: prefix.name + suffix.name,
            swingWtPrefixId: prefix.swingWtPrefixId,
            swingWtPrefixName: prefix.name,
            swingWtSuffixId: suffix.swingWtSuffixId,
            swingWtSuffixName: suffix.name,
          });
        });
      });
      setSwingWtData(swingWeights);

      setSwingWtOptions(
        swingWeights.map((sw) => {
          return { id: sw.swingWeightId.toString(), label: sw.name } as IDropdownOption;
        }),
      );
      swingWeightId = calculateSwingWeightIndex(thisDriver.swingWtPrefixId || 0, thisDriver.swingWtSuffixId || 0, swingWeights);
      setSwingWtListId(swingWeightId);

      let shaftData = [] as ShaftByShaftNameForDropdown[];
      switch (headTypeId) {
        case 1: //driver
        case 2: //fairway
          shaftData = await getShaftByShaftNameForDropdownData();
          break;
        case 3: //hybrid
          shaftData = await getHybridShaftByShaftNameForDropdownData();
          break;
      }
      // build manufacturer + shaft name dropdown options
      const shaftNameDropdownOptionMap = ShaftHelper.buildShaftDropdown(shaftData);
      setShaftDropdownData(shaftNameDropdownOptionMap);
      const tempShaftId = shaftNameDropdownOptionMap?.options.find((ironShaft) => ironShaft.label.endsWith(thisDriver.shaftName))?.id ?? '';
      setShaftId(thisDriver.shaftName ? tempShaftId : '');

      //find current shaftId given the shaft name (driver doesn't store shaftId)
      if (thisDriver.shaftName) {
        const shaft = shaftData.find((shaft) => shaft.name == thisDriver.shaftName);
        if (shaft) {
          setShaftId(shaft.id.toString());
        }
      }

      const shaftLengthDigitData = await getShaftLengthDigitData();
      const shaftLengthFractionData = await getShaftLengthFractionData();
      const fractionData = await getFractionData();
      const digitData = await getDigitData();
      const shaftLengthFractions = createCombinedShaftLengthDigitFractionList(shaftLengthDigitData, shaftLengthFractionData, digitData, fractionData);
      setShaftLengthFractionData(shaftLengthFractions);
      setShaftLengthFractionOptions(
        shaftLengthFractions.map((sl) => {
          return { id: sl.name, label: sl.name } as IDropdownOption;
        }),
      );
      //find the current shaft length club and assign it to the dropdown field
      if (thisDriver.shaftLengthDigitId !== 0) {
        const shaftLength = shaftLengthFractions.find((sl) => sl.shaftLengthDigitId == thisDriver.shaftLengthDigitId && sl.fractionId == thisDriver.shaftLengthFractionId);
        if (shaftLength) {
          setShaftLengthName(shaftLength.name);
        }
      }

      const shaftTippingFractionData = await getShaftTippingFractionData();
      const shaftTippingDigitFractions = createCombinedShaftTippingDigitFractionList(shaftTippingFractionData, digitData, fractionData);
      setShaftTippingFractionData(shaftTippingDigitFractions);
      setShaftTippingFractionOptions(
        shaftTippingDigitFractions.map((t) => {
          return { id: t.name, label: t.name } as IDropdownOption;
        }),
      );
      //find the current tipping value and assign it to the dropdown field
      if (thisDriver.shaftTippingFractionId !== 0) {
        const tipping = shaftTippingDigitFractions.find((t) => t.digit == thisDriver.shaftTippingDigit && t.fraction == thisDriver.shaftTippingFraction);
        if (tipping) {
          setTippingName(tipping.name);
        }
      }
    };
    asyncProc();
    // TODO: Improve UseEffect to avoid exhaustive-deps warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLoftOptions = (currentHand: number, modelId: number, lofts: LoftHandHeadModel[]) => {
    let headTypeLoftData = lofts.filter((l) => l.handId == currentHand && l.headModelId == modelId).sort((a, b) => a.sortId - b.sortId);
    const loftOptionList = headTypeLoftData.map((ht) => {
      let loft = lofts.find((l) => l.loftId == ht.loftId);
      return { id: loft?.loftId.toString() || '', label: loft?.name || '' } as IDropdownOption;
    });
    return loftOptionList;
  };

  //convert "RH", "LH" to the numerical handId
  const getCurrentHandId = (handName: string, hands: HandLookup[]) => {
    const handRecord = hands.find((hand) => hand.name == handName);
    return handRecord ? handRecord.handId : 0;
  };

  const bagClicked = () => {
    setThisDriver({ ...thisDriver, isActive: !thisDriver.isActive });
  };

  const handleFamilyChange = (id: string) => {
    const familyName = familyOptions.find((family) => family.id == id)?.label || '';
    const familyId = Number(id);
    setThisDriver({ ...thisDriver, familyId: familyId, familyName: familyName, headModelId: 0, headModelName: '' }); //deselect model when family is updated
    const familyModelList = getModels(familyId, currentHandId, handModels, familyModelData) || [];
    setModelOptions(
      familyModelList.map((model) => {
        return { id: model.headModelId?.toString() || '', label: model.name } as IDropdownOption;
      }),
    );
  };

  const getModels = (familyId: number | undefined, handId: number, handModels: HeadModelHandForDropdownDto[], familyModelData: HeadModelForDropdownDto[]) => {
    let modelList = [] as HeadModelForDropdownDto[];
    const modelIds = handModels.filter((model) => model.handId == handId).map((m) => m.headModelId);
    familyModelData
      .filter((m) => m.familyId == familyId)
      .forEach((m) => {
        if (modelIds.includes(m.headModelId)) {
          modelList.push(m);
        }
      });
    return modelList;
  };

  const getWeightLocations = (modelId: number, weightLocations: HeadWeightLocationDto[] | HeadWeightLocationAftDto[], weightLocationLookups: HeadWeightLocationLookup[]) => {
    const lookupIds = weightLocations.filter((loc) => loc.headModelId == modelId).map((loc) => loc.lookupId);
    const locations = weightLocationLookups.filter((loc) => lookupIds.includes(loc.headWeightLocationLookupId));
    return locations;
  };

  const getWeightNumbers = (modelId: number, weightNumbers: HeadWeightNumber[] | HeadWeightNumberAftDto[], weightNumberLookups: HeadWeightNumberLookup[]) => {
    const lookupIds = weightNumbers.filter((num) => num.headModelId == modelId).map((num) => num.lookupId);
    const numbers = weightNumberLookups.filter((num) => lookupIds.includes(num.headWeightNumberLookupId));
    return numbers;
  };

  const handleModelChange = async (id: string) => {
    const modelId = Number(id);
    const modelName = modelOptions.find((model) => model.id == id)?.label || '';

    setThisDriver((prev) => ({
      ...prev,
      headModelId: modelId,
      headModelName: modelName,
      loftId: 0,
    }));

    assignWeightLocationOptions(modelId, weightLocationData, weightLocationLookupData);
    assignWeightLocationAftOptions(modelId, weightLocationAftData, weightLocationLookupData);
    assignWeightNumberOptions(modelId, weightNumberData, weightNumberLookupData);
    assignWeightNumberAftOptions(modelId, weightNumberAftData, weightNumberLookupData);
    setLoftOptions(getLoftOptions(currentHandId, modelId, loftData));
  };

  const assignWeightLocationOptions = (modelId: number, weightLocationData: HeadWeightLocationDto[], weightLocationLookupData: HeadWeightLocationLookup[]) => {
    const weightLocations = getWeightLocations(modelId, weightLocationData, weightLocationLookupData);

    // Set Fwd/Toe options
    setWeightLocationOptions(
      weightLocations.map((wt) => ({
        id: wt.headWeightLocationLookupId.toString(),
        label: wt.name,
      })),
    );
  };

  const assignWeightLocationAftOptions = (modelId: number, weightLocationAftData: HeadWeightLocationAftDto[], weightLocationLookupData: HeadWeightLocationLookup[]) => {
    const weightAftLocations = getWeightLocations(modelId, weightLocationAftData, weightLocationLookupData);

    // Set Aft/Heel options
    setWeightLocationAftOptions(
      weightAftLocations.map((wt) => ({
        id: wt.headWeightLocationLookupId.toString(),
        label: wt.name.replace('Fwd', 'Aft').replace('Toe', 'Heel'),
      })),
    );
  };

  const assignWeightNumberOptions = (modelId: number, weightNumberData: HeadWeightNumber[], weightNumberLookupData: HeadWeightNumberLookup[]) => {
    const weightNumbers = getWeightNumbers(modelId, weightNumberData, weightNumberLookupData);

    // Set Fwd/Toe options
    setWeightNumberOptions(
      weightNumbers.map((wt) => ({
        id: wt.headWeightNumberLookupId.toString(),
        label: wt.name,
      })),
    );
  };

  const assignWeightNumberAftOptions = (modelId: number, weightNumberAftData: HeadWeightNumberAftDto[], weightNumberLookupData: HeadWeightNumberLookup[]) => {
    const weightAftNumbers = getWeightNumbers(modelId, weightNumberAftData, weightNumberLookupData);

    // Set Aft/Heel options
    setWeightNumberAftOptions(
      weightAftNumbers.map((wt) => ({
        id: wt.headWeightNumberLookupId.toString(),
        label: wt.name.replace('Fwd', 'Aft').replace('Toe', 'Heel'),
      })),
    );
  };

  const handleHandChange = (id: string) => {
    const currentHandIdData = getCurrentHandId(id, handData);

    setCurrentHandId(currentHandIdData);

    setLoftOptions(getLoftOptions(currentHandIdData, thisDriver?.headModelId || 0, loftData));
    const familyModelList = getModels(thisDriver.familyId, currentHandIdData, handModels, familyModelData) || [];

    //Get new Models dropdown and determine if current model should be reset or not based on the hand Id
    let thisModelOptions = familyModelList.map((model) => {
      return { id: model.headModelId?.toString() || '', label: model.name } as IDropdownOption;
    });
    setModelOptions(thisModelOptions);

    //if model exists in the new dropdown list, then keep it. Otherwise reset it
    let thisModelId = thisDriver.headModelId;
    let thisModelName = thisDriver.headModelName;

    if (!thisModelOptions.find((m) => Number(m.id) === thisModelId)) {
      thisModelId = 0;
      thisModelName = '';
    }

    //save the new Driver object
    setThisDriver((prev) => ({
      ...prev,
      hand: id,
      loftId: 0,
      loftName: '',
      headModelId: thisModelId,
      headModelName: thisModelName,
    }));
  };

  const handleSwingWtChange = (id: string) => {
    const sw = swingWtData.find((sw) => sw.swingWeightId == Number(id));
    if (sw) {
      setSwingWtListId(sw.swingWeightId);
      setThisDriver({ ...thisDriver, swingWtPrefixId: sw.swingWtPrefixId, swingWtPrefixName: sw.swingWtPrefixName, swingWtSuffixId: sw.swingWtSuffixId, swingWtSuffixName: sw.swingWtSuffixName });
    }
  };

  const calculateSwingWeightIndex = (prefixId: number, suffixId: number, weightCodes: IWeightCodes[]) => {
    let id = 0;
    const weightCode = weightCodes.find((wc) => wc.swingWtPrefixId == prefixId && wc.swingWtSuffixId == suffixId);
    if (weightCode) {
      id = weightCode.swingWeightId;
    }
    return id;
  };

  const handleShaftFinished = () => {
    setThisDriver({ ...thisDriver, isShaftLengthFinished: !thisDriver.isShaftLengthFinished });
  };

  const handleNotesChange = ({ target }: ChangeEvent<HTMLTextAreaElement>) => {
    setThisDriver({ ...thisDriver, notes: target.value });
  };

  const handleShaftLengthChange = (id: string) => {
    setShaftLengthName(id); //50 1/8
    const shaftLengthObject = shaftLengthFractionData.find((sl) => sl.name == id);
    setThisDriver({
      ...thisDriver,
      shaftLengthDigit: shaftLengthObject?.digit || '',
      shaftLengthDigitId: shaftLengthObject?.shaftLengthDigitId,
      shaftLengthDigitId1: shaftLengthObject?.digitId,
      shaftLengthFraction: shaftLengthObject?.fractionName || '',
      shaftLengthFractionId: shaftLengthObject?.shaftLengthFractionId || 0,
      shaftLengthFractionId1: shaftLengthObject?.shaftLengthFractionId || 0,
    });
  };

  const handleDropdownChange = (value: string, fieldName: string) => {
    setThisDriver({ ...thisDriver, [fieldName]: value });
  };

  const handleCtChange = (name: string) => {
    setThisDriver({ ...thisDriver, ctLocation: name });
  };

  const handleHeadWeightNumberChange = (id: string) => {
    const weightNumberName = weightNumberOptions.find((wt) => wt.id == id)?.label || '';
    setThisDriver({ ...thisDriver, headWeightNumberLookupId: Number(id), headWeightNumberLookupName: weightNumberName });
  };

  const handleHeadWeightNumberAftChange = (id: string) => {
    const weightNumberAftName = weightNumberAftOptions.find((wt) => wt.id == id)?.label || '';
    setThisDriver({
      ...thisDriver,
      headWeightNumberAftLookupId: Number(id),
      headWeightNumberAftLookupName: weightNumberAftName,
    });
  };

  const handleHeadWeightLocationChange = (id: string) => {
    const weightLocationName = weightLocationOptions.find((loc) => loc.id == id)?.label || '';
    setThisDriver({
      ...thisDriver,
      headWeightLocationLookupId: Number(id),
      headWeightLocationLookupName: weightLocationName,
    });
  };

  const handleHeadWeightLocationAftChange = (id: string) => {
    const weightLocationAftName = weightLocationAftOptions.find((loc) => loc.id == id)?.label || '';
    setThisDriver({
      ...thisDriver,
      headWeightLocationAftLookupId: Number(id),
      headWeightLocationAftLookupName: weightLocationAftName,
    });
  };

  const handleLoftChange = (id: string) => {
    const loftName = loftOptions.find((loft) => loft.id == id)?.label || '';
    setThisDriver({ ...thisDriver, loftId: Number(id), loftName: loftName });
  };

  const handleGripSizeChange = (id: string) => {
    const gripSize = gripSizeOptions.find((grip) => grip.id == id)?.label || '';
    setThisDriver({ ...thisDriver, gripSizeId: Number(id), gripSize: gripSize });
  };

  const handleSleeveChange = (id: string) => {
    const sleeveName = sleeveOptions.find((sleeve) => sleeve.id == id)?.label || '';
    setThisDriver({ ...thisDriver, sleeveId: Number(id), sleeveName: sleeveName });
  };

  const handleSettingChange = (id: string) => {
    const settingName = settingOptions.find((setting) => setting.id == id)?.label || '';
    setThisDriver({ ...thisDriver, settingId: Number(id), settingName: settingName });
  };

  const handleTippingChange = (id: string) => {
    setTippingName(id);
    const tippingDigitFraction = shaftTippingFractionData.find((t) => t.name == id);
    if (tippingDigitFraction) {
      setThisDriver({
        ...thisDriver,
        shaftTippingDigit: tippingDigitFraction.digit,
        shaftTippingFraction: tippingDigitFraction.fraction,
        shaftTippingFractionId: tippingDigitFraction.shaftTippingFractionId,
        shaftTippingFractionId1: tippingDigitFraction.shaftTippingFractionId,
      });
    }
  };

  const handleInputChange = (newValue: string, field: string) => {
    setThisDriver((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleSerialNumberSelect = async (data: ISerialNumberData) => {
    // Create a single update object to batch all changes
    const updates: any = {
      laserNo: data.serialNumber,
    };

    // Update hand
    let currentHandIdData = 0;
    if (data.details.hand) {
      const hand = data.details.hand.replace(/^M/, ''); // Convert MRH/MLH to RH/LH
      updates.hand = hand;
      currentHandIdData = getCurrentHandId(hand, handData);
      setCurrentHandId(currentHandIdData);
    }

    // Update model by finding the ID that matches the model name
    let family: Family | null = null;
    let modelList: HeadModelForDropdownDto[] | null = [];
    if (data.details.modelName) {
      // Get family information from the model
      family = await FamilyHelper.getFamilyForModel(data.details.modelName, headTypeId);
      if (family) {
        updates.familyId = family.familyId;
        updates.familyName = family.name;
        // Get models using the familyId from the model from the serial number
        modelList = getModels(family.familyId, currentHandIdData, handModels, familyModelData) || [];
        setModelOptions(
          modelList.map((model) => {
            return { id: model.headModelId?.toString() || '', label: model.name } as IDropdownOption;
          }),
        );
      }
    }

    // Use the modelList from the family of the model from the serial number
    const model = modelList?.find((option) => option.name.toLowerCase() === data.details.modelName.toLowerCase());

    if (data.details.modelName) {
      if (model) {
        updates.headModelId = Number(model.headModelId);
        updates.headModelName = model.name;

        assignWeightLocationOptions(Number(model.headModelId), weightLocationData, weightLocationLookupData);
        assignWeightLocationAftOptions(Number(model.headModelId), weightLocationAftData, weightLocationLookupData);
        assignWeightNumberOptions(Number(model.headModelId), weightNumberData, weightNumberLookupData);
        assignWeightNumberAftOptions(Number(model.headModelId), weightNumberAftData, weightNumberLookupData);
      } else {
        // Clear model-related fields if model not found in options
        updates.headModelId = 0;
        updates.headModelName = '';
        // Also clear dependent fields
        updates.loftId = 0;
        updates.loftName = '';
      }
    }

    // Update loft options after state is updated
    const handId = updates.hand ? getCurrentHandId(updates.hand, handData) : currentHandId;
    const modelId = Number(model?.headModelId) || 0;
    // Get loft options with the hand and model ids from the serial number
    const loftOptions = getLoftOptions(handId, modelId, loftData);
    setLoftOptions(loftOptions);

    // Update loft if found and model is valid
    if (data.details.loftName && data.details.modelName) {
      const loft = loftOptions.find((loft) => loft.label === data.details.loftName);
      if (loft) {
        updates.loftId = Number(loft.id);
        updates.loftName = loft.label;
      } else {
        // Clear loft fields if loft not found in options
        updates.loftId = 0;
        updates.loftName = '';
      }
    } else if (data.details.loftName) {
      // Clear loft fields if model is invalid
      updates.loftId = 0;
      updates.loftName = '';
    }

    // Update other fields
    if (data.details.titleistLoft) {
      updates.measuredLoft = data.details.titleistLoft.toString();
    }

    if (data.ctData?.ct) {
      updates.ct = data.ctData.ct.toString();
    }

    if (data.ctData?.ctLocation) {
      updates.ctLocation = data.ctData.ctLocation;
    }

    // Apply all updates in a single state update
    setThisDriver((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const serializeShafts = (setShaftName: string) => {
    const baseName = setShaftName.replace(/\s#\d+$/, '').trim();
    const shaftGroup = shaftDropdownData?.groups[baseName];
    if (!shaftGroup || shaftGroup.length === 0) return;

    // Find the index of the selected shaft
    const startIndex = shaftGroup.findIndex((s) => s.label.trim() === setShaftName.trim());
    const initialIndex = startIndex >= 0 ? startIndex : 0;
    const shaftIndex = Math.min(initialIndex, shaftGroup.length - 1);
    const shaft = shaftGroup[shaftIndex];
    const shaftName = shaft.label;
    const shaftPinstamp = shaft.shaftPinstamp;
    setThisDriver({ ...thisDriver, shaftName, shaftPinstamp });
  };

  return (
    <>
      <div className={styles.fullscreen}>
        <div className={styles.form}>
          <div className={styles.row}>
            <div className={styles.page_title}>{pageType} Club</div>
          </div>
          <div className={styles.tileRow}>
            <div>
              <EditableDropdown
                key={`hand-${thisDriver.hand}`}
                label="Hand"
                initialId={thisDriver.hand}
                options={handOptions}
                onChange={(id) => handleHandChange(id)}
                className={styles.editableDropdown}
              />
            </div>

            <div>
              <EditableDropdown
                key={`family-${thisDriver.familyId}`}
                label="Family"
                initialId={thisDriver.familyId?.toString() || ''}
                options={familyOptions}
                onChange={(id) => handleFamilyChange(id)}
                className={styles.editableDropdown}
                variant="large"
              />
            </div>

            <div>
              <EditableDropdown
                key={`model-${thisDriver.headModelId}`}
                label="Model"
                initialId={thisDriver.headModelId?.toString() || ''}
                options={modelOptions}
                onChange={(id) => handleModelChange(id)}
                className={styles.editableDropdown}
                variant="large"
              />
            </div>
            {isOnline && (
              <SerialNumberAutocomplete
                value={thisDriver.laserNo}
                onChange={(value: string) => handleInputChange(value, 'laserNo')}
                onSelect={handleSerialNumberSelect}
                variant="large"
                className={styles.serialInput}
              />
            )}
            {!isOnline && <EditableTile label="Serial No" value={thisDriver.laserNo} onChange={(value) => handleInputChange(value, 'laserNo')} variant="large" />}
            <div>
              <label className={styles.switch}>
                <input type="checkbox" checked={thisDriver.isActive} onChange={bagClicked} />
                <span className={styles.slider}></span>
              </label>
              <span className={styles.switch_text}>{`${thisDriver.isActive ? 'In the bag' : 'Out of Bag'}`}</span>
            </div>
          </div>
          <div className={styles.tileRow}>
            <EditableDropdown
              key={`loft-${thisDriver.loftName}`}
              label="Loft"
              initialId={thisDriver.loftId?.toString() || ''}
              options={loftOptions}
              onChange={(id) => handleLoftChange(id)}
              className={styles.editableDropdown}
            />
            <EditableTile label="Msrd. Loft" value={thisDriver.measuredLoft?.toString() || ''} onChange={(value) => handleInputChange(sanitize(value), 'measuredLoft')} variant="large" />
            <EditableDropdown
              label="Fwd/Toe Wt. Loc."
              initialId={thisDriver.headWeightLocationLookupId?.toString() || ''}
              options={weightLocationOptions}
              onChange={(id) => handleHeadWeightLocationChange(id)}
              variant="large"
              className={styles.editableDropdown}
            />
            {showWeightAft && (
              <EditableDropdown
                label="Aft/Heel Wt. Loc."
                initialId={thisDriver.headWeightLocationAftLookupId?.toString() || ''}
                options={weightLocationAftOptions}
                onChange={(id) => handleHeadWeightLocationAftChange(id)}
                variant="large"
                className={styles.editableDropdown}
              />
            )}
            {headTypeId == 1 && (
              <>
                <EditableTile label="CT" value={thisDriver.ct?.toString() || ''} onChange={(value) => handleInputChange(value, 'ct')} />
                <EditableDropdown label="CT Loc" initialId={thisDriver.ctLocation || ''} options={ctLocationOptions} onChange={(id) => handleCtChange(id)} className={styles.editableDropdown} />
              </>
            )}
            <EditableDropdown
              label="Swing Wt"
              initialId={swingWtListId?.toString() || ''}
              options={swingWtOptions}
              onChange={(id) => handleSwingWtChange(id)}
              className={styles.editableDropdown}
              variant="large"
            />
            <EditableTile label="Final HW" value={thisDriver.headWeight?.toString() || ''} onChange={(value) => handleInputChange(value, 'headWeight')} variant="large" />
            <EditableDropdown
              label="Fwd/Toe Wt. #"
              initialId={thisDriver.headWeightNumberLookupId?.toString() || ''}
              options={weightNumberOptions}
              onChange={(id) => handleHeadWeightNumberChange(id)}
              className={styles.editableDropdown}
              variant="large"
            />
            {showWeightAft && (
              <EditableDropdown
                label="Aft/Heel Wt. #"
                initialId={thisDriver.headWeightNumberAftLookupId?.toString() || ''}
                options={weightNumberAftOptions}
                onChange={(id) => handleHeadWeightNumberAftChange(id)}
                className={styles.editableDropdown}
                variant="large"
              />
            )}
          </div>
          <div className={styles.tileRow}>
            <EditableTile label="Hot Melt #1" value={thisDriver.ratGlue1} onChange={(value) => handleInputChange(value, 'ratGlue1')} variant="large" />
            <EditableTile label="Hot Melt #2" value={thisDriver.ratGlue2} onChange={(value) => handleInputChange(value, 'ratGlue2')} variant="large" />
            <EditableTile label="Hot Melt #3" value={thisDriver.ratGlue3} onChange={(value) => handleInputChange(value, 'ratGlue3')} variant="large" />
            <EditableTile label="Hot Melt #4" value={thisDriver.ratGlue4} onChange={(value) => handleInputChange(value, 'ratGlue4')} variant="large" />
            <EditableTile label="Hot Melt #5" value={thisDriver.ratGlue5} onChange={(value) => handleInputChange(value, 'ratGlue5')} variant="large" />
            <EditableTile label="Hot Melt #6" value={thisDriver.ratGlue6} onChange={(value) => handleInputChange(value, 'ratGlue6')} variant="large" />
            <EditableTile label="Hot Melt #7" value={thisDriver.ratGlue7} onChange={(value) => handleInputChange(value, 'ratGlue7')} variant="large" />
          </div>
          <div className={styles.row}>
            <div className={styles.page_title}>Shaft</div>
          </div>
          <div className={styles.row}>
            {/*<EditableDropdown label="Shaft" initialId={shaftId} options={shaftOptions} onChange={(id) => handleShaftChange(id)} className={styles.editableDropdown} type="rectangle" variant="xxl" />*/}
            <EditableDropdown
              label="Shaft"
              initialId={shaftId || ''}
              onChange={(shaftId) => {
                setShaftId(shaftId);
                const shaftName = shaftDropdownData?.map[shaftId].name || '';
                serializeShafts(shaftName);
              }}
              options={shaftDropdownData?.options || []}
              type="rectangle"
              alignment="left"
              variant="xxxxl"
            />

            <div className={`${styles.input} ${styles.radioButtons}`}>
              <label className={styles.radioLabel}>
                <input type="radio" name="groupName" value="option1" checked={!thisDriver.isShaftLengthFinished} onChange={handleShaftFinished} /> Cut
              </label>
              <label>
                <input type="radio" name="groupName" value="option1" checked={thisDriver.isShaftLengthFinished} onChange={handleShaftFinished} /> Finished
              </label>
            </div>
          </div>
          <div className={styles.tileRow}>
            <EditableDropdown
              label="Length"
              initialId={shaftLengthName}
              options={shaftLengthFractionOptions}
              onChange={(id) => handleShaftLengthChange(id)}
              className={styles.editableDropdown}
              variant="large"
            />
            <EditableDropdown label="Tipping" initialId={shaftTippingName} options={shaftTippingFractionOptions} onChange={(id) => handleTippingChange(id)} className={styles.editableDropdown} />
            <EditableDropdown
              label="Setting"
              initialId={thisDriver.settingId?.toString() || ''}
              options={settingOptions}
              onChange={(id) => handleSettingChange(id)}
              className={styles.editableDropdown}
            />
            <EditableDropdown label="Sleeve" initialId={thisDriver.sleeveId?.toString() || ''} options={sleeveOptions} onChange={(id) => handleSleeveChange(id)} className={styles.editableDropdown} />
            <EditableTile label="Cosmetic" value={thisDriver.shaftCosmetic} onChange={(value) => handleInputChange(value, 'shaftCosmetic')} variant="large" />
          </div>
          <div className={styles.row}>
            <div className={styles.page_title}>Grip</div>
          </div>
          <div className={styles.tileRow}>
            <EditableTile label="Grip Type" value={thisDriver.gripType} onChange={(value) => handleInputChange(value, 'gripType')} variant="extra" />
            <EditableDropdown
              label="Grip Size"
              initialId={thisDriver.gripSizeId?.toString() || ''}
              options={gripSizeOptions}
              onChange={(id) => handleGripSizeChange(id)}
              className={styles.editableDropdown}
              variant="large"
            />
            <EditableDropdown
              label="Round/Rib"
              initialId={thisDriver.rndRib || ''}
              options={rndRibOptions}
              onChange={(id) => handleDropdownChange(id, 'rndRib')}
              className={styles.editableDropdown}
              variant="large"
            />
            <EditableDropdown label="Logo" initialId={thisDriver.logo} options={logoOptions} onChange={(id) => handleDropdownChange(id, 'logo')} className={styles.editableDropdown} variant="large" />
            <EditableTile label="Grip Tape" value={thisDriver.tape} onChange={(value) => handleInputChange(value, 'tape')} variant="large" />
          </div>
          <div className={styles.row}>
            <div className={styles.page_title}>Notes</div>
          </div>
          <div className={styles.tileRow}>
            <textarea className={styles.formNotes} value={thisDriver.notes} name="notes" onChange={(e) => handleNotesChange(e)} rows={5} />
          </div>
          <div className={styles.section_header}>
            <button
              className={clubStyles.saveButton}
              onClick={() => {
                saveEditForm(thisDriver);
              }}
            >
              Save
            </button>
            <button className={clubStyles.cancelButton} onClick={closeEditForm}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
